import { createOptionsFrom } from "@/lib/common/Option";

export const PriceAlertTargetLabels = {
	Variant: "Product",
	CollectionVariants: "Collection Products",
	Collection: "Collection Value"
} as const;

export type PriceAlertTarget = keyof typeof PriceAlertTargetLabels;

export const PriceAlertTargetOptions = createOptionsFrom(PriceAlertTargetLabels);
